import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Flex from '../atoms/Flex';
import Stat from './Stat';
const StyledFlex = styled(Flex) `
    flex-wrap: wrap;

    @media only screen and (min-width: 992px) {
        flex-wrap: nowrap;
        margin-bottom: 60px;
    }
`;
const DashboardStats = ({ openValue, openDossiers, }) => {
    return (_jsxs(StyledFlex, { children: [_jsx(Stat, { label: "Openstaand saldo", isMoney: true, value: openValue }), _jsx(Stat, { label: "Aantal lopende zaken", value: openDossiers })] }));
};
export default DashboardStats;
